import { getDefaultStore, useAtom } from 'jotai';

import { atomWithToggle } from '~shared/jotai/atomWithToggle';

const resultsShowResultsAtom = atomWithToggle(true);
const reportsShowResultsAtom = atomWithToggle(false);

const useIsResultsShowResults = () => useAtom(resultsShowResultsAtom);
const useIsReportsShowResults = () => useAtom(reportsShowResultsAtom);

export function useShowResults(isActivityInProgress: boolean) {
  const isResultsShowResults = useIsResultsShowResults();
  const isReportsShowResults = useIsReportsShowResults();

  return isActivityInProgress ? isResultsShowResults : isReportsShowResults;
}

export function resetShowResults() {
  const store = getDefaultStore();
  store.set(resultsShowResultsAtom, true);
  store.set(reportsShowResultsAtom, false);
}

export function useCopyShowResultsToReport() {
  const [, setShowResults] = useIsReportsShowResults();
  const [isResultsShowResults] = useIsResultsShowResults();
  return () => setShowResults(isResultsShowResults);
}
